$(function(){

	//-- Config cookies
    App.citrus.init({
        "privacyUrl": "", /* Privacy policy url */

        "hashtag": "#energie-et-beaute-cookies", /* Open the panel with this hashtag */
        "cookieName": "energie-et-beaute-cookies", /* Cookie name */

        "orientation": "bottom", /* Banner position (top - bottom) */
        "showAlertBig": false, /* Show the small banner on bottom right */
        "showAlertSmall": false, /* Show the small banner on bottom right */
        "cookieslist": true, /* Show the cookie list */

        "adblocker": false, /* Show a Warning if an adblocker is detected */
        "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
        "highPrivacy": true, /* Disable auto consent */
        "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

        "removeCredit": true, /* Remove credit link */
        "moreInfoLink": true, /* Show more info link */
        "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */

        //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */
                      
        "readmoreLink": "/cookiespolicy" /* Change the default readmore link */
    });

    //-- Services

    // Google Analytics
    App.citrus.user.gtagUa = 'UA-150979250-1';
    // Facebook
    (App.citrus.job = App.citrus.job || []).push('gtag');
    // (App.citrus.job = App.citrus.job || []).push('facebook');

    //-- Display Cookies Banner
	var cookiesTextWrapper = '#tarteaucitronDisclaimerAlert',
		cookiesMainButton = '#tarteaucitronPersonalize',
		cookiesBanner = '#tarteaucitronAlertBig',
		cookiesText = "En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies afin de pouvoir améliorer votre expérience utilisateur.",
		cookiesMainButtonText = "J'accepte";

	setTimeout(function(){
		$(cookiesTextWrapper).html(cookiesText).addClass('is-init');
		$(cookiesMainButton).html(cookiesMainButtonText).addClass('is-init');
		$(cookiesBanner).addClass('is-active');
	},500);
	
});